import React, { useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLegalLocaleDocsDetails,fetchLegalDocumentInfosDetails, fetchOemLegalInfo} from '../../../Services/redux/LocalesRedux/LegallocaleDocumentsActions';
import LegalDocumentationForm from './LegalDocumentationForm';


function OemAdminLegalDocumentation() {
    const dispatch = useDispatch();
     const locales = useSelector((state) => state.oemAdminLocales.locales);
     const legalDocumentInfos = useSelector((state) => state.oemAdminLocales.legalDocumentInfo);
     const message = useSelector((state) => state.oemAdminLocales.message);

     useEffect(() => {
        dispatch(fetchLegalLocaleDocsDetails());
        dispatch(fetchOemLegalInfo());
        dispatch(fetchLegalDocumentInfosDetails());
     }, []);

     const callLegalDocInfo = () => {
       dispatch(fetchLegalDocumentInfosDetails());
     };

     useEffect(()=>{
      if(message!==""){
        dispatch(fetchLegalDocumentInfosDetails())
      }
     }, [message]);

  return (
    <div>
      <div>
      <LegalDocumentationForm locales={locales} legalDocumentInfos={legalDocumentInfos} callLegalDocInfo={callLegalDocInfo} />
      </div>
    </div>
  )
}

export default OemAdminLegalDocumentation

